<template>
  <div class="px-3 py-2">
    <div class="pb-[20px]">
      <VanField
        v-model="type"
        :label="t('story.base.type')"
        :placeholder="t('story.typePlaceholder')"
        class="bg-base-100 border rounded"
        is-link
        name="picker"
        readonly
        required
        @click="store.edit.showSelectType = true"
      />

      <!-- 故事人物 -->
      <div>
        <div class="flex items-center justify-between mt-3">
          <h2 class="text-base font-bold">{{ t(`story.role.title`) }}</h2>

          <button
            class="btn btn-xs rounded"
            @click="$router.push(`/story/edit/role`)"
          >
            {{ t(`story.base.edit`) }}
          </button>
        </div>
        <div class="border border-[#2f2f2f] p-4 mt-1 grid grid-cols-3 gap-1">
          <div v-for="item in store.currentStoryMateList" class="flex flex-col">
            <UserAvatar
              :avatar-url="item.mediaUrl"
              alt=""
              class="aspect-[3/4]"
            />
            <p class="text-center text-white my-1">{{ item.name }}</p>
            <p class="text-center text-xs">
              {{ t(`story.role.${item.role}`) }}
            </p>
          </div>

          <div
            class="w-full aspect-[3/4] bg-[#2f2f2f] flex justify-center items-center"
            @click="$router.push(`/story/edit/role/add`)"
          >
            <div class="text-center">
              <i class="iconfont icon-a- text-xs font-light"></i>
              <p class="text-xs mt-2">{{ t(`story.base.addRole`) }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 故事简述 -->
      <div>
        <div class="flex items-center justify-between mt-3">
          <h2 class="text-base font-bold">{{ t(`story.base.summary`) }}</h2>
          <div>
            <button
              v-if="store.form.description"
              class="btn btn-xs rounded mr-2"
              @click="store.resetOneForm('description')"
            >
              {{ t("Buttons.clear") }}
            </button>
            <button
              class="btn btn-xs rounded"
              @click="store.openGenerateModal('description')"
            >
              {{ t(`story.auto`) }}
            </button>
          </div>
        </div>
        <VanField
          v-model="store.form.description"
          :autosize="{ minHeight: 130 }"
          class="mt-2.5 text-[#ABABAB]"
          rows="1"
          type="textarea"
        />
      </div>

      <!-- 关联动态 -->
      <div>
        <div class="flex items-center justify-between mt-3">
          <h2 class="text-base font-bold">{{ t(`story.base.relation`) }}</h2>

          <button
            class="btn btn-xs rounded"
            @click="$router.push(`/story/edit/moment`)"
          >
            {{ t(`story.base.add`) }}
          </button>
        </div>

        <div
          v-for="(item, idx) in filteredMomentList"
          :key="item.uuid"
          class="flex gap-2 border-b px-4"
        >
          <div class="h-10 pt-3">
            <button
              class="btn btn-xs rounded px-4 py-1"
              @click="clickRemoveMoment(idx)"
            >
              <i class="iconfont icon-delete rounded" />
            </button>
          </div>
          <div class="relative flex-grow">
            <thread-item
              :avatar-url="item.mate.mediaUrl"
              :chat-message-list="item.chatMessagezz"
              :content="item.text"
              :enable-audio-play="false"
              :enable-chat-message-click="false"
              :enable-reaction-btn="false"
              :enableTextCollapsed="false"
              :from-mate="item.fromMate"
              :has-next="item.childId != null"
              :has-prev="item.parentId != null"
              :impression-reactions="[]"
              :mate-id="item.mate.uuid"
              :mate-tone-id="item.mate.mateToneId"
              :media-list="item.mediazz"
              :mention-matezz="item.mentionMatezz ?? []"
              :moment="item"
              :show-avatar="false"
              :show-comment="false"
              :show-reaction="false"
              :uuid="item.uuid"
              :visibility="item.visibility"
              class="border-b-0"
            />
            <div class="absolute top-0 right-0 left-0 bottom-0"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <VanPopup v-model:show="store.edit.showSelectType" position="bottom">
    <VanPicker
      :cancel-button-text="t('Buttons.cancel')"
      :columns="columns"
      :confirm-button-text="t('Buttons.momentSave')"
      @cancel="store.edit.showSelectType = false"
      @confirm="onConfirm"
    />
  </VanPopup>
</template>

<script lang="ts" setup>
import { useMoment } from "@/stores/moment";
import { useStoryBook } from "@/stores/story-book";
import { PickerConfirmEventParams, showConfirmDialog } from "vant";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const store = useStoryBook();
const momentStore = useMoment();

const type = computed(() => t(`story.type.${store.form.type}`));

const filteredMomentList = computed(() =>
  store.form.momentIdzz!.map((id) => momentStore.momentMap[id])
);

const clickRemoveMoment = (idx: number) => {
  showConfirmDialog({
    title: t("ConfirmModal.promptTitle"),
    message: t("ConfirmModal.sureDeletePost"),
    confirmButtonText: t("Buttons.confirm"),
    cancelButtonText: t("Buttons.cancel"),
  }).then(() => {
    store.form.momentIdzz!.splice(idx, 1);
  });
};

const columns = Array.from({ length: 29 }).map((_, idx) => ({
  text: t(`story.type.${idx + 1}`),
  value: idx + 1,
}));
const onConfirm = (value: PickerConfirmEventParams) => {
  store.form.type = value.selectedOptions[0]!.value! as number;
  store.edit.showSelectType = false;
};
</script>
